
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Förverkande av äganderätten</h5>

    <h6 style="font-weight: 500;">Lagliga konsekvenser</h6>
    <h6>{$selectedItem?.forfeiture_of_ownership?.legal_consequences ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Grund för förverkande</h6>
    <h6>{$selectedItem?.forfeiture_of_ownership?.grounds_for_forfeiture ?? "Uppgifter saknas"}</h6>
</div>